import { useEffect, useState } from 'react';

function getAffiliateFromLocation() {
  return new URLSearchParams(window.location.search).get('aff') || '';
}

export default function useAffiliate() {
  const [aff, setAff] = useState('');

  useEffect(() => {
    setAff(getAffiliateFromLocation());
  }, []);

  return [aff, setAff];
}
